import { defineComponent, ref } from "vue";
import Svg from "../../../../core/svg";
import { OptionalVueProp, VueEmit } from "../../../../core/vueHelpers";

export enum SearchEvents
{
    Search = "search"
}

const browseSearchClasses =
{
    BrowseSearch: "browseSearch",
    BrowseSearchBox: "browseSearchBox"
}

const SearchContainer = defineComponent(
{
    props:
    {
        searchContainerID: OptionalVueProp(String),
        searchBoxID: OptionalVueProp(String),
        searchContainerClasses: OptionalVueProp(String),
        searchBoxClasses: OptionalVueProp(String),
        placeholderText: OptionalVueProp(String),
        value: OptionalVueProp(String),
    },
    emits:
    {
        search: VueEmit<(searchValue: string) => void>()
    },
    setup(props, { emit })
    {
        const searchContainer = ref<HTMLInputElement>();

        const searchCallback = () =>
        {
            if (!searchContainer.value)
            {
                return;
            }

            emit(SearchEvents.Search, searchContainer.value.value);
        }

        const debouncedSearchCallback = window.skyward.debounce(searchCallback, 300, 1000);

        const getSearchParts = () =>
        {
            const searchParts: JSX.Element[] = [];

            searchParts.push((<input
                ref={searchContainer}
                id={props.searchBoxID}
                class={[browseSearchClasses.BrowseSearchBox, props.searchBoxClasses]}
                type="search"
                role="searchbox"
                placeholder={props.placeholderText}
                autocomplete="off"
                onInput={debouncedSearchCallback}
                value={props.value}
            />));
            searchParts.push((<a
                id="browse_searchButton"
                class="button searchBoxButton searchIcon svgNoHover ButtonIconOnly"
                href="javascript:void(0)"
                onClick={searchCallback}>
                <Svg name="Search" aria-label="Search for Text"/>
            </a>));

            return searchParts;            
        }

        return () => (
            <div id={props.searchContainerID} class={[browseSearchClasses.BrowseSearch, props.searchContainerClasses]} role="search">
                {getSearchParts()}
            </div>
        );
    }
});

export default SearchContainer;